import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';
import store from "./state/store";
import piniaPluginPersist from 'pinia-plugin-persist';
import { createPinia } from 'pinia'
// import VueGoogleMaps from 'vue3-google-map';

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css'; // 引入Ant Design Vue的样式文件
import BootstrapVueNext from 'bootstrap-vue-next';
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import Maska from 'maska';
import VueFeather from 'vue-feather';

import { noSpecialCharsDirective } from '@/directive/noSpecialCharsDirective';
import infiniteScroll from 'vue3-infinite-scroll-better'

import '@/assets/scss/config/material/app.scss';
import '@vueform/slider/themes/default.css';
import '@/assets/scss/mermaid.min.css';
import 'bootstrap/dist/js/bootstrap.bundle'
import trimSpaceDirective from "@/directive/trimSpaceDirective";
import {focusDirective} from "@/directive/focus";
import {emailSpecialCharsDirective} from "@/directive/emailSpecialCharsDirective";
import {inputNumberDigitalDetection} from "@/directive/inputNumberDigitalDetection";

const pinia = createPinia();
pinia.use(piniaPluginPersist)

// app.config.globalProperties.urlResources = 'http://192.168.8.201:8080'

AOS.init({
    easing: 'ease-out-back',
    duration: 1000
});

const app = createApp(App);
app.use(store)
    .use(pinia)
    .use(router)
    .use(VueApexCharts)
    .use(Antd)
    .use(BootstrapVueNext)
    .component(VueFeather.type, VueFeather)
    .directive('no-special-chars', noSpecialCharsDirective)
    .directive('email-special-chars', emailSpecialCharsDirective)
    .directive("trim-space", trimSpaceDirective)
    .directive("focus", focusDirective)
    .directive("inputNumber", inputNumberDigitalDetection)
    .use(infiniteScroll)
    .use(Maska)
    .use(i18n)
    .use(vClickOutside).mount('#app');
